import { createContext } from "react";

export const RequestLoader = createContext({});
export const ToastContext = createContext({});
export const PushNotificationContext = createContext({});
export const MetaHandler = createContext({});
export const platformHandler = createContext({});
